import React from 'react';

interface CTagProps {
  children: React.ReactNode;
  color?: string;
  prefix?: 'dot' | React.ReactNode;
}

const getColor = (color: string) => {
  if (/^#([0-9A-F]{3}){1,2}$/i.test(color)) {
    color = color.replace(/^#/, '');
    color =
      color.length === 3
        ? color
            .split('')
            .map((char) => char + char)
            .join('')
        : color;
    const bigint = parseInt(color, 16);
    return `${(bigint >> 16) & 255}, ${(bigint >> 8) & 255}, ${bigint & 255}`;
  }

  switch (color) {
    case 'green':
      return 'var(--val-cgreen-base)';
    case 'red':
      return '255, 0, 0';
    case 'blue':
      return 'var(--val-cblue-base)';
    case 'yellow':
      return 'var(--val-cyellow-base)';
    case 'purple':
      return 'var(--val-cpurple-base)';
    default:
      return 'var(--val-cgray-base)';
  }
};

const CTag = (props: CTagProps) => {
  const color = getColor(props.color || '');
  return (
    <div
      className="rounded-full flex w-fit items-center justify-center px-[10px] py-[3px] gap-[6px]"
      style={{
        backgroundColor: `rgba(${color}, 0.1)`,
        color: `rgb(${color})`,
      }}
    >
      {props.prefix === 'dot' ? (
        <div
          className="rounded-full"
          style={{
            width: '6px',
            height: '6px',
            backgroundColor: `rgb(${color})`,
          }}
        />
      ) : (
        props.prefix
      )}
      <span className="text-xs font-semibold">{props.children}</span>
    </div>
  );
};

export default CTag;
